class ReturnTo extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['input']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!window.location.search) {
      this.inputEl.remove()
      return
    }

    const params = new URLSearchParams(window.location.search)
    const returnTo = params.get('return_to')

    if (!returnTo) {
      this.inputEl.remove()
      return
    }

    this.inputEl.value = returnTo
  }

  setupListeners () {
    this.listeners.add(this.formEl, 'submit', this.onSubmit.bind(this))
  }

  onSubmit (e) {
    const invalidEls = e.target
      .closest('form')
      .querySelectorAll('[required]:not(:valid)')
    if (!invalidEls.length) return

    e.stopPropagation()
    e.preventDefault()
    invalidEls[0].focus()
  }

  get inputEl () {
    return this.els?.input?.element
  }

  get formEl () {
    return this.closest('form')
  }
}

if (!customElements.get('return-to')) {
  customElements.define('return-to', ReturnTo)
}
